export const ALL_STOCK_REQUESTING = 'ALL_STOCK_REQUESTING';
export const ALL_STOCK_REQUEST_SUCCESS = 'ALL_STOCK_REQUEST_SUCCESS';
export const ALL_STOCK_REQUEST_ERROR = 'ALL_STOCK_REQUEST_ERROR';

export const MARGIN_LIST_REQUESTING = 'MARGIN_LIST_REQUESTING';
export const MARGIN_LIST_REQUEST_SUCCESS = 'MARGIN_LIST_REQUEST_SUCCESS';
export const MARGIN_LIST_REQUEST_ERROR = 'MARGIN_LIST_REQUEST_ERROR';

export const LIST_MESSAGE_REQUESTING = 'LIST_MESSAGE_REQUESTING';
export const LIST_MESSAGE_REQUEST_SUCCESS = 'LIST_MESSAGE_REQUEST_SUCCESS';
export const LIST_MESSAGE_REQUEST_ERROR = 'LIST_MESSAGE_REQUEST_ERROR';

export const SNAPSHOT_REQUESTING = 'SNAPSHOT_REQUESTING';
export const SNAPSHOT_REQUEST_SUCCESS = 'SNAPSHOT_REQUEST_SUCCESS';
export const SNAPSHOT_REQUEST_ERROR = 'SNAPSHOT_REQUEST_ERROR';

export const SNAPSHOT_UNDERLYING_REQUESTING = 'SNAPSHOT_UNDERLYING_REQUESTING';
export const SNAPSHOT_UNDERLYING_REQUEST_SUCCESS = 'SNAPSHOT_UNDERLYING_REQUEST_SUCCESS';
export const SNAPSHOT_UNDERLYING_REQUEST_ERROR = 'SNAPSHOT_UNDERLYING_REQUEST_ERROR';

export const PS_SNAPSHOT_REQUESTING = 'PS_SNAPSHOT_REQUESTING';
export const PS_SNAPSHOT_REQUEST_SUCCESS = 'PS_SNAPSHOT_REQUEST_SUCCESS';
export const PS_SNAPSHOT_REQUEST_ERROR = 'PS_SNAPSHOT_REQUEST_ERROR';

export const PS_INDEX_REQUESTING = 'PS_INDEX_REQUESTING';
export const PS_INDEX_REQUEST_SUCCESS = 'PS_INDEX_REQUEST_SUCCESS';
export const PS_INDEX_REQUEST_ERROR = 'PS_INDEX_REQUEST_ERROR';

export const LOLE_SNAPSHOT_REQUESTING = 'LOLE_SNAPSHOT_REQUESTING';
export const LOLE_SNAPSHOT_REQUEST_SUCCESS = 'LOLE_SNAPSHOT_REQUEST_SUCCESS';
export const LOLE_SNAPSHOT_REQUEST_ERROR = 'LOLE_SNAPSHOT_REQUEST_ERROR';

export const LOLE_HSX_SNAPSHOT_REQUESTING = 'LOLE_HSX_SNAPSHOT_REQUESTING';
export const LOLE_HSX_SNAPSHOT_REQUEST_SUCCESS = 'LOLE_HSX_SNAPSHOT_REQUEST_SUCCESS';
export const LOLE_HSX_SNAPSHOT_REQUEST_ERROR = 'LOLE_HSX_SNAPSHOT_REQUEST_ERROR';

export const CLEAR_PART_REQUEST = 'CLEAR_PART_REQUEST';
export const CLEAR_SNAPSHOT_REQUEST = 'CLEAR_SNAPSHOT_REQUEST';
export const SNAPSHOT_PART_REQUESTING = 'SNAPSHOT_PART_REQUESTING';
export const SNAPSHOT_PART_REQUEST_SUCCESS = 'SNAPSHOT_PART_REQUEST_SUCCESS';
export const SNAPSHOT_PART_REQUEST_ERROR = 'SNAPSHOT_PART_REQUEST_ERROR';

export const STOCK_INFO_REQUESTING = 'STOCK_INFO_REQUESTING';
export const STOCK_INFO_REQUEST_SUCCESS = 'STOCK_INFO_REQUEST_SUCCESS';
export const STOCK_INFO_REQUEST_ERROR = 'STOCK_INFO_REQUEST_ERROR';

export const ALL_ORD_REQUESTING = 'ALL_ORD_REQUESTING';
export const ALL_ORD_REQUEST_SUCCESS = 'ALL_ORD_REQUEST_SUCCESS';
export const ALL_ORD_REQUEST_ERROR = 'ALL_ORD_REQUEST_ERROR';

export const PT_LIST_REQUESTING = 'PT_LIST_REQUESTING';
export const PT_LIST_REQUEST_SUCCESS = 'PT_LIST_REQUEST_SUCCESS';
export const PT_LIST_REQUEST_ERROR = 'PT_LIST_REQUEST_ERROR';

export const PS_LIST_REQUESTING = 'PS_LIST_REQUESTING';
export const PS_LIST_REQUEST_SUCCESS = 'PS_LIST_REQUEST_SUCCESS';
export const PS_LIST_REQUEST_ERROR = 'PS_LIST_REQUEST_ERROR';

export const CW_LIST_REQUESTING = 'CW_LIST_REQUESTING';
export const CW_LIST_REQUEST_SUCCESS = 'CW_LIST_REQUEST_SUCCESS';
export const CW_LIST_REQUEST_ERROR = 'CW_LIST_REQUEST_ERROR';

export const BOND_LIST_REQUESTING = 'BOND_LIST_REQUESTING';
export const BOND_LIST_REQUEST_SUCCESS = 'BOND_LIST_REQUEST_SUCCESS';
export const BOND_LIST_REQUEST_ERROR = 'BOND_LIST_REQUEST_ERROR';

export const LIST_30_REQUESTING = 'LIST_30_REQUESTING';
export const LIST_30_REQUEST_SUCCESS = 'LIST_30_REQUEST_SUCCESS';
export const LIST_30_REQUEST_ERROR = 'LIST_30_REQUEST_ERROR';

export const LIST_ETF_REQUESTING = 'LIST_ETF_REQUESTING';
export const LIST_ETF_REQUEST_SUCCESS = 'LIST_ETF_REQUEST_SUCCESS';
export const LIST_ETF_REQUEST_ERROR = 'LIST_ETF_REQUEST_ERROR';

export const BRANCH_CODE_REQUESTING = 'BRANCH_CODE_REQUESTING';
export const BRANCH_CODE_REQUEST_SUCCESS = 'BRANCH_CODE_REQUEST_SUCCESS';
export const BRANCH_CODE_REQUEST_ERROR = 'BRANCH_CODE_REQUEST_ERROR';

export const NOI_CAP_REQUESTING = 'NOI_CAP_REQUESTING';
export const NOI_CAP_REQUEST_SUCCESS = 'NOI_CAP_REQUEST_SUCCESS';
export const NOI_CAP_REQUEST_ERROR = 'NOI_CAP_REQUEST_ERROR';

export const SUMMARY_REQUESTING = 'SUMMARY_REQUESTING';
export const SUMMARY_REQUEST_SUCCESS = 'SUMMARY_REQUEST_SUCCESS';
export const SUMMARY_REQUEST_ERROR = 'SUMMARY_REQUEST_ERROR';

export const GET_STOCK_BY_ID_REQUESTING = 'GET_STOCK_BY_ID_REQUESTING';
export const GET_STOCK_BY_ID_REQUEST_SUCCESS =
  'GET_STOCK_BY_ID_REQUEST_SUCCESS';
export const GET_STOCK_BY_ID_REQUEST_ERROR = 'GET_STOCK_BY_ID_REQUEST_ERROR';

export const INDEX_REQUESTING = 'INDEX_REQUESTING';
export const INDEX_REQUEST_SUCCESS = 'INDEX_REQUEST_SUCCESS';
export const INDEX_REQUEST_ERROR = 'INDEX_REQUEST_ERROR';

export const WORLD_INDEX_REQUESTING = 'WORLD_INDEX_REQUESTING';
export const WORLD_INDEX_REQUEST_SUCCESS = 'WORLD_INDEX_REQUEST_SUCCESS';
export const WORLD_INDEX_REQUEST_ERROR = 'WORLD_INDEX_REQUEST_ERROR';

export const NDATA_SNAPSHOT_REQUESTING = 'NDATA_SNAPSHOT_REQUESTING';
export const NDATA_SNAPSHOT_REQUEST_SUCCESS = 'NDATA_SNAPSHOT_REQUEST_SUCCESS';
export const NDATA_SNAPSHOT_REQUEST_ERROR = 'NDATA_SNAPSHOT_REQUEST_ERROR';

export const TRADE_HIS_PS_REQUESTING = 'TRADE_HIS_PS_REQUESTING';
export const TRADE_HIS_PS_REQUEST_SUCCESS = 'TRADE_HIS_PS_REQUEST_SUCCESS';
export const TRADE_HIS_PS_REQUEST_ERROR = 'TRADE_HIS_PS_REQUEST_ERROR';

export const TRADE_HIS_PS_Add_ROW = 'TRADE_HIS_PS_Add_ROW';
export const SORT_TYPE = 'SORT_TYPE';

export const DM_NGANH_REQUESTING = 'DM_NGANH_REQUESTING';
export const DM_NGANH_REQUEST_SUCCESS = 'DM_NGANH_REQUEST_SUCCESS';
export const DM_NGANH_REQUEST_ERROR = 'DM_NGANH_REQUEST_ERROR';

export const TOP_INTEREST_REQUESTING = 'TOP_INTEREST_REQUESTING';
export const TOP_INTEREST_REQUEST_SUCCESS = 'TOP_INTEREST_REQUEST_SUCCESS';
export const TOP_INTEREST_REQUEST_ERROR = 'TOP_INTEREST_REQUEST_ERROR';

export const TOP_VOLUME_REQUESTING = 'TOP_VOLUME_REQUESTING';
export const TOP_VOLUME_SUCCESS = 'TOP_VOLUME_SUCCESS';
export const TOP_VOLUME_ERROR = 'TOP_VOLUME_ERROR';